<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
  
</style>


// WEBPACK FOOTER //
// src/App.vue